(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["glimtiq-collection-rail"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('glimtiq-collection-rail'))customElements.define('glimtiq-collection-rail',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;this.ready=true;this.panel=this.querySelector('.gr-panel');this.tabs=[...this.querySelectorAll('[role=tab]')];this.status=this.querySelector('.gr-status');this.cache=new Map();
      this.click=(event)=>{const tab=event.target.closest('[role=tab]');if(tab)this.select(tab);const arrow=event.target.closest('[data-direction]');if(arrow)this.panel.querySelector('.gr-track')?.scrollBy({left:Number(arrow.dataset.direction)*this.panel.clientWidth*.8,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});};
      this.key=(event)=>{const tab=event.target.closest('[role=tab]');if(!tab)return;let i=this.tabs.indexOf(tab);if(event.key==='ArrowRight')i=(i+1)%this.tabs.length;else if(event.key==='ArrowLeft')i=(i+this.tabs.length-1)%this.tabs.length;else if(event.key==='Home')i=0;else if(event.key==='End')i=this.tabs.length-1;else return;event.preventDefault();this.tabs[i].focus();this.select(this.tabs[i]);};
      this.submit=(event)=>this.add(event);this.onScroll=()=>this.controls();this.addEventListener('click',this.click);this.addEventListener('keydown',this.key);this.addEventListener('submit',this.submit);this.panel.addEventListener('scroll',this.onScroll,true);
      this.resize=new ResizeObserver(()=>this.controls());this.resize.observe(this.panel);
      if(this.dataset.order!=='manual'){this.visibleLoader=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.visibleLoader.disconnect();this.load(this.dataset.url);}},{rootMargin:'120px'});this.visibleLoader.observe(this);}else this.controls();
    }
    select(tab){this.visibleLoader?.disconnect();this.tabs.forEach(t=>{t.setAttribute('aria-selected',String(t===tab));t.tabIndex=t===tab?0:-1;});this.panel.setAttribute('aria-labelledby',tab.id);this.load(tab.dataset.url);}
    async load(path){
      this.request?.abort();this.request=new AbortController();const signal=this.request.signal;const url=new URL(path,location.origin);if(this.dataset.order!=='manual')url.searchParams.set('sort_by',this.dataset.order);this.querySelector('.gr-view').href=url.pathname+url.search;url.searchParams.set('section_id','glimtiq-product-feed');this.panel.setAttribute('aria-busy','true');this.status.textContent='';
      try{let html=this.cache.get(url.href);if(!html){const response=await fetch(url,{signal});if(!response.ok)throw new Error();const doc=new DOMParser().parseFromString(await response.text(),'text/html');const track=doc.querySelector('[data-feed-products]');if(!track)throw new Error();[...track.children].slice(Number(this.dataset.limit)).forEach(card=>card.remove());html=track.outerHTML;this.cache.set(url.href,html);}if(signal.aborted)return;this.panel.innerHTML=html;}
      catch(error){if(error.name!=='AbortError'){this.panel.innerHTML='';this.status.textContent=this.dataset.error;}}
      finally{if(!signal.aborted){this.panel.removeAttribute('aria-busy');this.controls();}}
    }
    controls(){const track=this.panel.querySelector('.gr-track');if(track&&!track.querySelector('.gr-more')){const item=document.createElement('li');item.className='gr-card gr-more';const link=this.querySelector('.gr-view').cloneNode(true);link.className='';link.textContent=link.textContent.replace('→','').trim();const icon=document.createElement('span');icon.className='gr-more-icon';icon.setAttribute('aria-hidden','true');icon.textContent='→';link.prepend(icon);item.append(link);track.append(item);}const prev=this.querySelector('[data-direction="-1"]');const next=this.querySelector('[data-direction="1"]');prev.disabled=!track||track.scrollLeft<=2;next.disabled=!track||track.scrollLeft+track.clientWidth>=track.scrollWidth-2;}
    async add(event){const form=event.target.closest('.gr-add');if(!form)return;const drawer=document.querySelector('cart-drawer');if(!drawer)return;event.preventDefault();const button=form.querySelector('button');if(button.disabled)return;button.disabled=true;this.status.textContent='';const data=new FormData(form);data.append('sections',drawer.getSectionsToRender().map(s=>s.id).join(','));data.append('sections_url',location.pathname);let added=false;
      try{const response=await fetch(form.action+'.js',{method:'POST',body:data,headers:{Accept:'application/json'}});const state=await response.json();if(!response.ok||state.status)throw new Error(state.description||this.dataset.error);added=true;drawer.setActiveElement(button);drawer.classList.remove('is-empty');drawer.renderContents(state);}
      catch(error){if(added){location.assign(this.dataset.cartUrl);return;}this.status.textContent=error.message||this.dataset.error;}
      finally{button.disabled=false;}
    }
    disconnectedCallback(){this.visibleLoader?.disconnect();this.request?.abort();this.resize?.disconnect();this.removeEventListener('click',this.click);this.removeEventListener('keydown',this.key);this.removeEventListener('submit',this.submit);this.panel?.removeEventListener('scroll',this.onScroll,true);this.ready=false;}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glimtiq-home-banner"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('glimtiq-home-banner')) customElements.define('glimtiq-home-banner',class extends HTMLElement {
    connectedCallback(){
      this.track=this.querySelector('.gh-track');
      this.slides=[...this.querySelectorAll('.gh-slide')];
      this.controls=this.querySelector('.gh-controls');
      if(this.slides.length<2)return;
      this.controls.hidden=false;
      this.desktop=matchMedia('(min-width: 768px)');
      this.index=0;
      this.looped=false;
      this.position=(slide)=>this.track.scrollLeft+slide.getBoundingClientRect().left+slide.clientWidth/2-this.track.getBoundingClientRect().left-this.track.clientWidth/2;
      this.jump=(slide)=>{this.track.scrollTo({left:this.position(slide),behavior:'instant'});};
      this.nearest=()=>{
        const center=this.track.getBoundingClientRect().left+this.track.clientWidth/2;
        return [...this.track.children].reduce((best,slide)=>Math.abs(slide.getBoundingClientRect().left+slide.clientWidth/2-center)<Math.abs(best.getBoundingClientRect().left+best.clientWidth/2-center)?slide:best);
      };
      this.configure=()=>{
        const shouldLoop=this.classList.contains('gh-banner--home')&&this.desktop.matches;
        if(shouldLoop===this.looped)return;
        if(shouldLoop){
          this.before=this.slides.at(-1).cloneNode(true);
          this.after=this.slides[0].cloneNode(true);
          for(const clone of [this.before,this.after]){
            clone.classList.add('gh-clone');
            clone.setAttribute('aria-hidden','true');
            clone.inert=true;
            clone.removeAttribute('data-shopify-editor-block');
            clone.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));
          }
          this.track.prepend(this.before);
          this.track.append(this.after);
          this.looped=true;
          this.jump(this.slides[this.index]);
        }else{
          this.before?.remove();this.after?.remove();
          this.before=this.after=null;
          this.looped=false;
          this.jump(this.slides[this.index]);
        }
        this.sync();
      };
      this.sync=()=>{
        const slide=this.nearest();
        this.index=slide===this.before?this.slides.length-1:slide===this.after?0:this.slides.indexOf(slide);
        this.querySelector('.gh-count').textContent=`${this.index+1} / ${this.slides.length}`;
        this.querySelector('[data-step="-1"]').disabled=!this.looped&&this.index===0;
        this.querySelector('[data-step="1"]').disabled=!this.looped&&this.index===this.slides.length-1;
      };
      this.normalize=()=>{
        const slide=this.nearest();
        if(slide===this.before)this.jump(this.slides.at(-1));
        if(slide===this.after)this.jump(this.slides[0]);
        this.sync();
      };
      this.scroll=()=>{
        cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(this.sync);
        clearTimeout(this.settle);this.settle=setTimeout(this.normalize,180);
      };
      this.click=(event)=>{const button=event.target.closest('[data-step]');if(button)this.go(this.index+Number(button.dataset.step));};
      this.select=(event)=>{const i=this.slides.indexOf(event.target.closest('.gh-slide'));if(i>=0)this.go(i);};
      this.track.addEventListener('scroll',this.scroll,{passive:true});
      this.controls.addEventListener('click',this.click);
      this.addEventListener('shopify:block:select',this.select);
      this.desktop.addEventListener('change',this.configure);
      this.observer=new ResizeObserver(()=>{this.jump(this.slides[this.index]);this.sync();});this.observer.observe(this.track);
      this.configure();this.sync();
    }
    go(index){
      const slide=index<0&&this.looped?this.before:index>=this.slides.length&&this.looped?this.after:this.slides[index];
      if(!slide)return;
      this.track.scrollTo({left:this.position(slide),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
    }
    disconnectedCallback(){this.track?.removeEventListener('scroll',this.scroll);this.controls?.removeEventListener('click',this.click);this.removeEventListener('shopify:block:select',this.select);this.desktop?.removeEventListener('change',this.configure);this.observer?.disconnect();cancelAnimationFrame(this.frame);clearTimeout(this.settle);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["glimtiq-navigation"]) return;
  try {
    
  if (!customElements.get('glimtiq-navigation')) customElements.define('glimtiq-navigation', class extends HTMLElement {
    connectedCallback() {
      if(this.ready) return;
      this.ready=true;
      const headerCart=document.getElementById('cart-icon-bubble');
      this.syncCart=()=>{const target=this.querySelector('.gn-cart-count');const bubble=headerCart?.querySelector('.cart-count-bubble');if(target&&headerCart)target.innerHTML=bubble?.outerHTML||'';};
      if(headerCart){this.cartObserver=new MutationObserver(this.syncCart);this.cartObserver.observe(headerCart,{childList:true,subtree:true,characterData:true});this.syncCart();}
      document.body.classList.add('gn-enabled');
      this.last=window.scrollY;
      this.update=()=>{
        this.frame=null;
        const y=Math.max(0,window.scrollY);
        const scrolled=y>250;
        if(document.body.classList.contains('gn-scrolled')!==scrolled) document.body.classList.toggle('gn-scrolled',scrolled);
        if(Math.abs(y-this.last)>8 || y<80) {
          const down=y>this.last && y>180;
          if(document.body.classList.contains('gn-header-down')!==down) document.body.classList.toggle('gn-header-down',down);
          this.last=y;
        }
      };
      this.scroll=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
      window.addEventListener('scroll',this.scroll,{passive:true});
      this.querySelector('.gn-search').addEventListener('click',(event)=>{
        event.stopPropagation();
        const search=document.querySelector('details-modal.header__search');
        if(!search) return;
        document.body.classList.remove('gn-header-down');
        search.querySelector('summary').click();
        search.returnFocus=event.currentTarget;
      });
      this.querySelector('.gn-top').addEventListener('click',()=>window.scrollTo({top:0,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
      this.querySelector('.gn-cart').addEventListener('click',event=>{const drawer=document.querySelector('cart-drawer');if(drawer){event.preventDefault();drawer.open(event.currentTarget);}});
      this.update();
    }
    disconnectedCallback(){this.cartObserver?.disconnect();window.removeEventListener('scroll',this.scroll);cancelAnimationFrame(this.frame);document.body.classList.remove('gn-enabled','gn-scrolled','gn-header-down');}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
